// namespace = userInfo
import { mainWeb, mainWebPostData } from '../../config/net'
import api from '../../tools/api-tools'

export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  getters: {
    getUserInfo (state) {
      return state.userInfo
    }
  },
  actions: {
    loadUserInfo ({ commit }) {
      return api.post(`${mainWeb}/OnlineMall/ajax/MobileOnlineMall.ashx`, mainWebPostData('accountinfo')).then(res => {
        console.log(res)
        let model = JSON.parse(res.data.Model)
        let data = model || {}
        // data.isUserRegistAfter20190901 = true
        commit('initUserInfo', data)
      })
    }
  },
  mutations: {
    initUserInfo (state, data) {
      state.userInfo = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user-info.js